// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b-mQ","fullView":"styles_fullView__1rm_e"};